import {
  Box,
  Card,
  CardHeader,
  CardHeaderProps,
  Typography,
} from '@mui/material';
import { Customer } from 'api/user-domain/user-domain.types';
import { getCustomerFullName } from '../customer.utils';
import CustomerAvatar from './customer-avatar.component';
import CustomerSubheader from './customer-subheader.component';
import LoyaltyChips from './loyalty-chips.component';

type CustomerCardProps = {
  customer: Partial<Customer>;
  cardHeaderProps?: CardHeaderProps;
};

export const CustomerCard = ({
  customer,
  cardHeaderProps,
}: CustomerCardProps) => {
  const customerFullName = getCustomerFullName(customer);

  return (
    <Card>
      <CardHeader
        avatar={<CustomerAvatar customer={customer} />}
        title={
          <Box display="flex" alignItems="center">
            {customerFullName ? (
              <Typography
                variant="h3"
                sx={{
                  wordBreak: 'break-all',
                }}
              >
                <Box component="span" mr={1}>
                  {customerFullName}
                </Box>
                <LoyaltyChips customer={customer} />
              </Typography>
            ) : (
              <LoyaltyChips customer={customer} />
            )}
          </Box>
        }
        subheader={<CustomerSubheader customer={customer} />}
        {...cardHeaderProps}
      />
    </Card>
  );
};

export default CustomerCard;
